import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, switchMap, tap } from 'rxjs';
import { AttachmentAttachmentRead, AttachmentService } from '../openapi';
import { environment } from '../../environments/environment';
import * as fileSaver from 'file-saver';
import { getFileNameFromHttpResponse } from './helpers';

export interface AttachmentWrite {
  file: File;
  tag?: string;
  type?: string;
}

@Injectable()
export class UploaderAttachmentsService {
  constructor(
    private http: HttpClient,
    private attachmentService: AttachmentService
  ) {
  }

  public uploadAttachment(payload: AttachmentWrite): Observable<AttachmentAttachmentRead> {
    const formData = new FormData();
    formData.append('file', payload.file);
    return this.http.post<AttachmentAttachmentRead>(environment.apiBasePath + '/attachments', formData)
      .pipe(
        switchMap(attachment =>
          this.attachmentService.apiAttachmentsPatchItemAttachmentItem({
            id: attachment?.id || '',
            attachment: {
              tag: payload.tag
            }
          })
        )
      );
  }

  public downloadAttachment(id: string, name?: string): Observable<any> {
    return this.http
      .get(`${environment.apiBasePath}/attachments/${id}/download`, {
        responseType: 'blob',
        observe: 'response'
      }).pipe(
        tap(result => {
          fileSaver.saveAs(result.body as any, name || getFileNameFromHttpResponse(result) || 'example.pdf');
        })
      );
  }
}
